/* ARBACH V7 — interactivity (vanilla). Replaces the Next.js Header disclosure
   pattern and the framer-motion PhotoSlider. No dependencies. */
(function () {
  'use strict';

  /* --------------------------------------------------------------------
     Header disclosures (language switcher + menu) — mutually exclusive,
     close on Escape (focus back to trigger), outside pointerdown, focusout.

     Split into two lifetimes, and that split is the whole point of this
     section (Nachtrag zu Paket 16):

       * THREE `document` listeners — pointerdown, Escape, Tab-trap. Bound
         EXACTLY ONCE per page load by bindDisclosureGlobals(). They iterate
         the module-level `disclosureItems` registry, never a local snapshot,
         so anything registered later is picked up automatically.
       * PER-ELEMENT listeners — the trigger's `click` and the root's
         `focusout`. Re-bound per section, guarded by DISC_READY.

     Why not simply call initDisclosures() again on shopify:section:load:
     the three document listeners used to close over a local `items` array.
     A second call would add three more, pointing at a stale snapshot of
     nodes that are no longer in the document — double Escape handlers,
     double Tab traps. Worse than the bug it fixes.
     -------------------------------------------------------------------- */
  var DISC_READY = 'data-arbach-disc-ready';
  // Focusable descendants that are actually visible (display:none duplicates
  // — the inactive desktop/mobile instance — yield none, so they never trap).
  var DISC_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var disclosureItems = [];
  var disclosureGlobalsBound = false;

  function discFocusables(container) {
    return Array.prototype.slice.call(container.querySelectorAll(DISC_FOCUSABLE))
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
  }
  function anyMobileOpen() {
    return disclosureItems.some(function (it) { return it.mobile && it.btn.getAttribute('aria-expanded') === 'true'; });
  }

  // Auftrag 20, N17: ein offenes Sprachmenue haelt mindestens 16 px Abstand zum
  // Bildschirmrand. Gemessen statt geraten — Lage und Breite des Knopfs wechseln
  // je Kopf (Marke/Shop), Sprache (RTL) und Warenkorb-Zaehler. Nur fuer den
  // Sprachwechsler: das mobile Markenmenue ist absichtlich randlos breit.
  var DISC_RAND = 16;
  function fitPanel(item) {
    var p = item.panel;
    p.style.translate = '';
    p.style.maxWidth = '';
    if (!item.root.classList.contains('arbach-switcher')) return;
    if (p.hasAttribute('hidden')) return;
    var vw = document.documentElement.clientWidth;
    var r = p.getBoundingClientRect();
    if (!r.width || !vw) return;
    if (r.width > vw - 2 * DISC_RAND) {
      p.style.maxWidth = (vw - 2 * DISC_RAND) + 'px';
      r = p.getBoundingClientRect();
    }
    var dx = 0;
    if (r.right > vw - DISC_RAND) dx = (vw - DISC_RAND) - r.right;
    if (r.left + dx < DISC_RAND) dx = DISC_RAND - r.left;
    if (dx) p.style.translate = Math.round(dx) + 'px 0';
  }

  function setOpen(item, open) {
    var wasOpen = item.btn.getAttribute('aria-expanded') === 'true';
    item.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { item.panel.removeAttribute('hidden'); }
    else { item.panel.setAttribute('hidden', ''); }
    fitPanel(item);
    var lo = item.btn.getAttribute('data-label-open');
    var lc = item.btn.getAttribute('data-label-closed');
    if (open && lo) { item.btn.setAttribute('aria-label', lo); }
    else if (!open && lc) { item.btn.setAttribute('aria-label', lc); }

    // Mobile-only: lock body scroll + trap focus while open; restore on close.
    if (item.mobile) {
      if (open) {
        document.documentElement.classList.add('arbach-scroll-lock');
        // Fokus auf den Panel-Container (tabindex="-1"), NICHT auf den ersten
        // Link. Sonst zeigt der erste Nav-Link beim Oeffnen einen Fokus-Ring,
        // der auf z. B. /pages/philosophie kaum vom goldenen Aktiv-Rahmen auf
        // "Ueber uns" zu unterscheiden ist. Tastaturnutzer landen weiter im
        // Panel und kommen mit Tab zum ersten Link — der Tab-Trap unten greift
        // weiter, weil panel.contains(panel) === true.
        try { item.panel.focus({ preventScroll: true }); } catch (e) { item.panel.focus(); }
      } else if (wasOpen) {
        // Return focus to the trigger only if focus was inside this disclosure.
        if (item.root.contains(document.activeElement)) { item.btn.focus(); }
      }
    }
    // Drop the scroll lock once no mobile disclosure remains open.
    if (!open && !anyMobileOpen()) {
      document.documentElement.classList.remove('arbach-scroll-lock');
    }
  }
  function closeAllDisclosures(except) {
    disclosureItems.forEach(function (it) { if (it !== except) setOpen(it, false); });
  }

  // Drop registry entries whose root has left the document (or that sit inside
  // `within`). The per-element listeners die with the detached nodes; only the
  // registry reference would keep them alive.
  function releaseDisclosures(within) {
    for (var i = disclosureItems.length - 1; i >= 0; i--) {
      var it = disclosureItems[i];
      var detached = !document.documentElement.contains(it.root);
      var inside = !!(within && within.contains && (within === it.root || within.contains(it.root)));
      if (!detached && !inside) continue;
      it.root.removeAttribute(DISC_READY);
      disclosureItems.splice(i, 1);
    }
    // A mobile panel that was open when its section got replaced would leave
    // the scroll lock on <html> forever — nothing else ever clears it.
    if (!anyMobileOpen()) {
      document.documentElement.classList.remove('arbach-scroll-lock');
    }
  }

  // The three document-level listeners. Guarded so they exist exactly once for
  // the whole page lifetime, no matter how often a section re-renders.
  function bindDisclosureGlobals() {
    if (disclosureGlobalsBound) return;
    disclosureGlobalsBound = true;

    window.addEventListener('resize', function () {
      disclosureItems.forEach(function (item) {
        if (item.btn.getAttribute('aria-expanded') === 'true') fitPanel(item);
      });
    });
    document.addEventListener('pointerdown', function (e) {
      disclosureItems.forEach(function (item) {
        if (item.btn.getAttribute('aria-expanded') !== 'true') return;
        if (!item.root.contains(e.target)) setOpen(item, false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      disclosureItems.forEach(function (item) {
        if (item.btn.getAttribute('aria-expanded') === 'true') {
          setOpen(item, false);
          item.btn.focus();
        }
      });
    });
    // Trap Tab / Shift+Tab within an open mobile disclosure panel.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var open = disclosureItems.filter(function (it) {
        return it.mobile && it.btn.getAttribute('aria-expanded') === 'true';
      })[0];
      if (!open) return;
      var f = discFocusables(open.panel);
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !open.panel.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !open.panel.contains(active)) { e.preventDefault(); first.focus(); }
      }
    });
  }

  // Only disclosures inside the header count. The shop layout uses
  // .arbach-shophead (v2), the brand layout .arbach-header — accept both,
  // otherwise the language switcher in the shop header never initialises.
  // Walks parentNode instead of Element.closest to match the file's ES5 style.
  function insideHeader(el) {
    var node = el;
    while (node && node.classList) {
      if (node.classList.contains('arbach-header') || node.classList.contains('arbach-shophead')) return true;
      node = node.parentNode;
    }
    return false;
  }

  function initDisclosures(root) {
    bindDisclosureGlobals();
    releaseDisclosures(null);

    var scope = (root && root.querySelectorAll) ? root : document;
    var discs = [];
    if (scope !== document && scope.classList && scope.classList.contains('arbach-disc')) {
      discs.push(scope);
    }
    var found = scope.querySelectorAll('.arbach-disc');
    for (var i = 0; i < found.length; i++) discs.push(found[i]);

    for (var d = 0; d < discs.length; d++) {
      var discRoot = discs[d];
      if (discRoot.getAttribute(DISC_READY) === 'true') continue; // idempotency guard
      if (!insideHeader(discRoot)) continue;
      var btn = discRoot.querySelector('.arbach-disc__btn');
      var panel = discRoot.querySelector('.arbach-disc__panel');
      if (!btn || !panel) continue;

      discRoot.setAttribute(DISC_READY, 'true');
      var item = {
        root: discRoot,
        btn: btn,
        panel: panel,
        mobile: discRoot.classList.contains('arbach-disc--mobile')
      };
      disclosureItems.push(item);
      setOpen(item, false);
      bindDisclosureItem(item);
    }
  }

  // Per-element listeners. Separate function so `item` is captured per
  // iteration without relying on block scoping (ES5: var is function-scoped).
  function bindDisclosureItem(item) {
    item.btn.addEventListener('click', function () {
      var isOpen = item.btn.getAttribute('aria-expanded') === 'true';
      closeAllDisclosures(item);
      setOpen(item, !isOpen);
    });
    // Close only when focus moves to a KNOWN element OUTSIDE this disclosure.
    // A null relatedTarget must NOT close it: on a mobile touch-tap, the tapped
    // link / submit button does not take focus, so the previously focused entry
    // blurs to null — closing here would hide the panel between pointerdown and
    // click, eating the tap so the link never navigates / the form never submits.
    // Click-outside is handled by the pointerdown listener, Escape by keydown.
    item.root.addEventListener('focusout', function (e) {
      var next = e.relatedTarget;
      if (next && !item.root.contains(next)) setOpen(item, false);
    });
  }

  /* --------------------------------------------------------------------
     Photo slider — crossfade, autoplay (pause on hover/focus, stop after
     interaction), arrow keys (RTL aware), dots, sr-only live counter.

     Since Paket 16 a slide is a section block and may contain a focusable
     CTA. Three consequences, all handled below:
       a) inactive slides must leave the a11y tree AND the tab order
          (opacity:0 alone leaves their buttons tabbable) — setInert().
       b) focus sitting inside a slide that gets hidden must be moved,
          otherwise it vanishes (WCAG 2.4.3 / 2.4.7) — go() / restoreFocus().
       c) the theme editor re-renders the whole section on every block change,
          which orphans this closure — shopify:section:load re-runs the init,
          guarded by SLIDER_READY so listeners/timers never double up.
     -------------------------------------------------------------------- */
  var SLIDER_READY = 'data-arbach-slider-ready';
  var SLIDER_TABINDEX = 'data-arbach-prev-tabindex';
  var SUPPORTS_INERT = ('inert' in document.createElement('div'));
  var SLIDE_FOCUSABLE = 'a[href],button,input,select,textarea,iframe,[tabindex]';
  var sliderInstances = [];

  // Stop + forget every registered slider that has left the document (or that
  // lives inside `within`). Without this, a section re-render in the theme
  // editor leaves an orphaned setInterval ticking against detached nodes.
  function releaseSliders(within) {
    for (var i = sliderInstances.length - 1; i >= 0; i--) {
      var inst = sliderInstances[i];
      var detached = !document.documentElement.contains(inst.region);
      var inside = !!(within && within.contains && (within === inst.region || within.contains(inst.region)));
      if (!detached && !inside) continue;
      inst.stop();
      inst.region.removeAttribute(SLIDER_READY);
      sliderInstances.splice(i, 1);
    }
  }

  function collectSliders(scope) {
    var out = [];
    if (scope !== document && scope.getAttribute && scope.getAttribute('data-arbach-slider') !== null) {
      out.push(scope);
    }
    var found = scope.querySelectorAll('[data-arbach-slider]');
    for (var i = 0; i < found.length; i++) out.push(found[i]);
    return out;
  }

  function initSliders(root) {
    releaseSliders(null);
    var scope = (root && root.querySelectorAll) ? root : document;
    var sliders = collectSliders(scope);
    Array.prototype.forEach.call(sliders, function (region) {
      if (region.getAttribute(SLIDER_READY) === 'true') return; // idempotency guard
      var slides = region.querySelectorAll('.arbach-slide');
      var total = slides.length;
      if (total < 1) return;
      region.setAttribute(SLIDER_READY, 'true');
      var dots = region.querySelectorAll('[data-slider-dot]');
      var live = region.querySelector('[data-slider-live]');
      var labelTpl = region.getAttribute('data-slide-label') || 'Photo {current} of {total}';
      var interval = parseInt(region.getAttribute('data-autoplay') || '6000', 10);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var rtl = (document.documentElement.getAttribute('dir') === 'rtl');

      var index = 0, paused = false, interacted = false, timer = null;

      function label(n) { return labelTpl.replace('{current}', n).replace('{total}', total); }

      // (a) A hidden slide must be invisible to screen readers AND untabbable.
      // `inert` does both in one go; where it is missing we park the tabindex
      // of every focusable descendant and restore it verbatim afterwards.
      function setInert(slide, on) {
        if (on) {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        } else {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('inert');
        }
        if (SUPPORTS_INERT) return;
        var f = slide.querySelectorAll(SLIDE_FOCUSABLE);
        for (var i = 0; i < f.length; i++) {
          if (on) {
            if (!f[i].hasAttribute(SLIDER_TABINDEX)) {
              var cur = f[i].getAttribute('tabindex');
              f[i].setAttribute(SLIDER_TABINDEX, cur === null ? '' : cur);
            }
            f[i].setAttribute('tabindex', '-1');
          } else if (f[i].hasAttribute(SLIDER_TABINDEX)) {
            var prev = f[i].getAttribute(SLIDER_TABINDEX);
            if (prev === '') f[i].removeAttribute('tabindex');
            else f[i].setAttribute('tabindex', prev);
            f[i].removeAttribute(SLIDER_TABINDEX);
          }
        }
      }

      function render() {
        for (var i = 0; i < total; i++) {
          if (i === index) { slides[i].classList.add('is-active'); setInert(slides[i], false); }
          else { slides[i].classList.remove('is-active'); setInert(slides[i], true); }
        }
        for (var d = 0; d < dots.length; d++) {
          if (d === index) dots[d].setAttribute('aria-current', 'true');
          else dots[d].removeAttribute('aria-current');
        }
        if (live) live.textContent = label(index + 1);
      }

      // (b) Focus that lived inside the outgoing slide is homeless after the
      // switch: hand it to the incoming slide's own control, else to an arrow.
      function restoreFocus() {
        var target = slides[index].querySelector(SLIDE_FOCUSABLE);
        if (!target) target = nextBtn || prevBtn;
        if (!target) return;
        try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
      }
      function go(n) {
        var active = document.activeElement;
        var fromSlide = null;
        if (active && active !== document.body) {
          for (var i = 0; i < total; i++) {
            if (slides[i] === active || slides[i].contains(active)) { fromSlide = slides[i]; break; }
          }
        }
        index = (n % total + total) % total;
        render();
        if (fromSlide && fromSlide !== slides[index]) restoreFocus();
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }

      function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }
      function startTimer() {
        stopTimer();
        if (paused || interacted || reduce) return;
        timer = setInterval(function () { go(index + 1); }, interval);
      }
      function userInteract(fn) { return function () { interacted = true; stopTimer(); fn(); }; }

      var prevBtn = region.querySelector('[data-slider-prev]');
      var nextBtn = region.querySelector('[data-slider-next]');
      if (prevBtn) prevBtn.addEventListener('click', userInteract(prev));
      if (nextBtn) nextBtn.addEventListener('click', userInteract(next));
      Array.prototype.forEach.call(dots, function (dot) {
        dot.addEventListener('click', userInteract(function () {
          go(parseInt(dot.getAttribute('data-index'), 10) || 0);
        }));
      });

      region.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); interacted = true; stopTimer(); (rtl ? next : prev)(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); interacted = true; stopTimer(); (rtl ? prev : next)(); }
      });
      region.addEventListener('mouseenter', function () { paused = true; stopTimer(); });
      region.addEventListener('mouseleave', function () { paused = false; startTimer(); });
      region.addEventListener('focusin', function () { paused = true; stopTimer(); });
      region.addEventListener('focusout', function (e) {
        if (!region.contains(e.relatedTarget)) { paused = false; startTimer(); }
      });

      sliderInstances.push({
        region: region,
        slides: slides,
        stop: stopTimer,
        // Editor only: show the block the merchant just clicked, without
        // tripping the one-way `interacted` switch that kills autoplay.
        select: function (i) { paused = true; stopTimer(); go(i); },
        deselect: function () { paused = false; startTimer(); }
      });

      render();
      startTimer();
    });
  }

  // (c) Theme editor. Without these the slider is dead after the first block
  // edit: the section HTML is replaced, this closure is orphaned, every slide
  // stays at opacity 0 and arrows/dots do nothing.
  function initEditorHooks() {
    document.addEventListener('shopify:section:unload', function (e) {
      releaseSliders(e.target);
      releaseDisclosures(e.target);
    });
    document.addEventListener('shopify:section:load', function (e) {
      initSliders(e.target);
      // Header re-render: without this the burger menu and the language
      // switcher are dead until the preview reloads. Pre-existing gap, fixed
      // here because assets/arbach.js is A6-owned.
      initDisclosures(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      for (var i = 0; i < sliderInstances.length; i++) {
        var inst = sliderInstances[i];
        for (var s = 0; s < inst.slides.length; s++) {
          if (inst.slides[s] === e.target || inst.slides[s].contains(e.target)) { inst.select(s); return; }
        }
      }
    });
    document.addEventListener('shopify:block:deselect', function () {
      for (var i = 0; i < sliderInstances.length; i++) sliderInstances[i].deselect();
    });
  }

  function init() { initDisclosures(); initSliders(); initEditorHooks(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* --------------------------------------------------------------------
   Willkommen (/pages/willkommen) — QR opt-in form, "Deine Vorteile".
   Posts directly to Klaviyo's public Client Subscribe API (company_id/
   list_id are public IDs read from data-attributes, no secret involved).
   Self-contained: own DOMContentLoaded guard, does not touch
   initDisclosures/initSliders above.

   Consent: no checkbox — a pre-ticked box would be invalid anyway. The
   submit itself is the active consent, and the page states next to the
   button what is being agreed to (arbach.willkommen.consent_note).
   NOTE: list WmgU9Q has been on SINGLE opt-in since 2026-08-11, so no
   confirmation click follows. An older version of this comment claimed
   double-opt-in — wrong since that date.

   Channel split: which list a sign-up lands in is decided by utm_source,
   see QUELLEN/LIST_BANNER below.
   -------------------------------------------------------------------- */
(function () {
  'use strict';

  // https://developers.klaviyo.com/en/reference/create_client_subscription
  // (klaviyo/openapi, stable/apis/create_client_subscription.json) — default
  // revision "2026-07-15"; "subscriptions" lives INSIDE profile.data.attributes,
  // not as a sibling of "profile". Verify again here if this ever starts failing.
  var KLAVIYO_REVISION = '2026-07-15';

  // Kanaltrennung: an den zwei Listen haengen zwei Flows mit zwei verschiedenen
  // Versprechen — "Vorteile Vor-Ort" auf WmgU9Q, "Willkommen Online — Vorstart"
  // (mit dem Starttag) auf SpmTZk. Landet eine Banner-Anmeldung in der
  // Vor-Ort-Liste, bekommt sie die falsche Mail, und hinterher laesst sich nicht
  // mehr sagen, welcher Kanal was gebracht hat.
  // WmgU9Q kommt NICHT von hier, sondern aus data-list-id (Section-Setting),
  // damit die Vor-Ort-Liste im Theme-Editor umstellbar bleibt.
  var LIST_BANNER = 'SpmTZk';

  // Beschriftungen fuer properties.quelle. Bewusst dieselbe Sprache und Machart
  // wie der bisherige harte Wert "QR Ladengeschaeft", damit die Auswertung ueber
  // alte und neue Anmeldungen hinweg lesbar bleibt.
  var QUELLEN = {
    aufsteller: 'QR Aufsteller',
    kassa: 'QR Kassa',
    schaufenster: 'QR Schaufenster',
    banner: 'Banner Online',
    'startseite-band': 'Band Startseite'
  };

  // Kanaele, die in die Online-Liste gehen. Seit 08.09.2026 sind es zwei: die
  // duenne Leiste ueber dem Header (banner) und das Ankuendigungsband auf der
  // Startseite (startseite-band). Beide versprechen dasselbe und muessen
  // denselben Flow treffen -- die Vorstart-Mail mit dem Starttag auf SpmTZk.
  // Auseinandergehalten werden sie hinterher ueber properties.quelle, nicht
  // ueber die Liste. Faehrt ein neuer Kanal auf, gehoert er HIER dazu, sonst
  // bekommt er still die Vor-Ort-Mail.
  // Array und indexOf statt Objekt-Nachschlagen: ein Objekt haette bei
  // ?utm_source=constructor einen Treffer geliefert.
  var KANAELE_ONLINE = ['banner', 'startseite-band'];
  var QUELLE_OHNE_PARAMETER = 'Direktlink';

  // Absichtlich ohne URLSearchParams — der Rest dieser Datei ist ES5. Klein
  // geschrieben und auf 40 Zeichen begrenzt, damit ein manipulierter Parameter
  // nicht als Muell in der Profil-Property landet.
  function kanalAusUrl() {
    var treffer = /[?&]utm_source=([^&#]*)/.exec(window.location.search);
    if (!treffer) return '';
    var wert;
    try {
      wert = decodeURIComponent(treffer[1].replace(/\+/g, ' '));
    } catch (e) {
      wert = treffer[1];
    }
    return wert.trim().toLowerCase().slice(0, 40);
  }

  function initOptinForm() {
    var form = document.getElementById('arbach-optin');
    if (!form) return;

    var companyId = form.getAttribute('data-company-id');
    var listId = form.getAttribute('data-list-id');
    var submitBtn = form.querySelector('.arbach-optin__submit');
    var wrap = form.parentNode;
    var successMsg = wrap ? wrap.querySelector('[data-optin-success]') : null;
    var errorMsg = wrap ? wrap.querySelector('[data-optin-error]') : null;
    var emailInput = document.getElementById('arbach-optin-email');
    var nameInput = document.getElementById('arbach-optin-name');

    var labelDefault = submitBtn ? submitBtn.textContent : '';
    var labelSending = submitBtn ? submitBtn.getAttribute('data-label-sending') : '';

    function hide(el) { if (el) el.hidden = true; }
    function show(el) { if (el) el.hidden = false; }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      // Kanal erst hier lesen, nicht beim Init: der Parameter steht in der URL,
      // die beim Absenden gilt (der Kurzlink /geschenk leitet auf
      // ?utm_source=kassa&utm_medium=qr um, der Parameter ist also da).
      var kanal = kanalAusUrl();
      var zielListe = KANAELE_ONLINE.indexOf(kanal) > -1 ? LIST_BANNER : listId;
      var quelle = QUELLEN[kanal] || (kanal ? kanal : QUELLE_OHNE_PARAMETER);
      if (!companyId || !zielListe) { return; }

      hide(errorMsg);
      if (submitBtn) {
        submitBtn.disabled = true;
        if (labelSending) submitBtn.textContent = labelSending;
      }

      var firstName = nameInput ? nameInput.value.trim() : '';
      var audienceInputs = form.querySelectorAll('input[name="audience"]:checked');
      var audience = Array.prototype.map.call(audienceInputs, function (i) { return i.value; }).join(',');

      var profileAttributes = {
        email: emailInput.value.trim(),
        properties: { quelle: quelle },
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };
      if (firstName) { profileAttributes.first_name = firstName; }
      if (audience) { profileAttributes.properties.praeferenz = audience; }

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: zielListe } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': KLAVIYO_REVISION
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (response.status === 202) {
          form.reset();
          hide(form);
          show(successMsg);
        } else {
          show(errorMsg);
        }
      }).catch(function () {
        show(errorMsg);
      }).then(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (labelDefault) submitBtn.textContent = labelDefault;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOptinForm);
  } else {
    initOptinForm();
  }

  /* --------------------------------------------------------------------
     Trennpunkte der Fusszeilen-Kontaktzeilen (Auftrag 20, N27). Punkt und
     folgender Eintrag sind im Markup eine Einheit — die Zeile bricht deshalb
     nur VOR einem Punkt um, nie dahinter. Steht eine Einheit am Zeilenanfang,
     wird ihr Punkt unsichtbar (visibility, der Platz bleibt: sonst rueckte die
     Einheit vielleicht in die Zeile davor und der Punkt fehlte dort).
     Gemessen statt per Breakpoint geraten — wo umbrochen wird, haengt von
     Breite, Sprache und Oeffnungszeiten-Text ab.
     -------------------------------------------------------------------- */
  function markTrennpunkte() {
    var teile = document.querySelectorAll('.arbach-shopfoot__teil, .arbach-footer__contact .teil');
    for (var i = 0; i < teile.length; i++) {
      var t = teile[i], vor = t.previousElementSibling;
      var anfang = !!vor && t.getBoundingClientRect().top >= vor.getBoundingClientRect().bottom - 1;
      t.classList.toggle('is-zeilenanfang', anfang);
    }
  }
  var trennRaf = 0;
  function planeTrennpunkte() {
    if (trennRaf) return;
    trennRaf = window.requestAnimationFrame(function () { trennRaf = 0; markTrennpunkte(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', planeTrennpunkte);
  } else {
    planeTrennpunkte();
  }
  window.addEventListener('load', planeTrennpunkte);
  window.addEventListener('resize', planeTrennpunkte);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(planeTrennpunkte);
})();
